export default __webpack_public_path__ + "static/media/change-tyre.bcda192e.jpeg";